import React, { useContext, useMemo, useState, useRef } from "react";
import "../css/tabla.css";
import { HolderOutlined, SearchOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button, Table, Input, Space } from "antd";
import Highlighter from "react-highlight-words";
import Footer from "../components/Footer";
import Swal from "sweetalert2";
const RowContext = React.createContext({});

const DragHandle = () => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext);
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{ cursor: "move" }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

const handleSearch = (
  selectedKeys,
  confirm,
  searchedColumn,
  setSearchedColumn,
) => {
  confirm();
  setSearchedColumn(searchedColumn);
};

const handleReset = (clearFilters, setSearchText) => {
  clearFilters();
  setSearchText("");
};

const columns = (
  searchText,
  setSearchText,
  searchedColumn,
  setSearchedColumn,
  searchInput,
) => [
  {
    key: "sort",
    align: "center",
    width: 80,
    render: () => <DragHandle />,
  },
  {
    title: "IDENTIFICACION",
    dataIndex: "identificacion",
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Buscar ${searchedColumn}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(
              selectedKeys,
              confirm,
              searchedColumn,
              setSearchedColumn,
            )
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(
                selectedKeys,
                confirm,
                searchedColumn,
                setSearchedColumn,
              )
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, setSearchText)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record.identificacion
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === "identificacion" ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  },
  {
    title: "DEPARTAMENTO",
    dataIndex: "departamento",
    filters: [
      { text: "ANTIOQUIA", value: "ANTIOQUIA" },
      { text: "ARMENIA", value: "ARMENIA" },
      { text: "CALDAS", value: "CALDAS" },
      { text: "RISARALDA", value: "RISARALDA" },
      { text: "ATLANTICO", value: "ATLANTICO" },
      { text: "BOLIVAR", value: "BOLIVAR" },
      { text: "LA_GUAJIRA", value: "LA_GUAJIRA" },
      { text: "MAGDALENA", value: "MAGDALENA" },
      { text: "SUCRE", value: "SUCRE" },
      { text: "CESAR", value: "CESAR" },
      { text: "CUNDINAMARCA", value: "CUNDINAMARCA" },
      { text: "BOGOTA", value: "BOGOTA" },
      { text: "SANTANDER", value: "SANTANDER" },
      { text: "NORTE DE SANTANDER", value: "NORTE DE SANTANDER" },
    ],
    onFilter: (value, record) => record.departamento.includes(value),
  },
  {
    title: "REGIONAL",
    dataIndex: "regional",
    filters: [
      { text: "ANTIOQUIA", value: "ANTIOQUIA" },
      { text: "CARIBE", value: "CARIBE" },
      { text: "CENTRO", value: "CENTRO" },
      { text: "ORIENTE", value: "ORIENTE" },
    ],
    onFilter: (value, record) => record.regional.includes(value),
  },
  {
    title: "NORMATIVIDAD",
    dataIndex: "normatividad",
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Buscar ${searchedColumn}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(
              selectedKeys,
              confirm,
              searchedColumn,
              setSearchedColumn,
            )
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(
                selectedKeys,
                confirm,
                searchedColumn,
                setSearchedColumn,
              )
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, setSearchText)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record.normatividad
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === "normatividad" ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  },
];

const initialData = [
  {
    key: "1",
    identificacion: "BARRANQUILLA",
    departamento: "ATLANTICO",
    regional: "CARIBE",
    normatividad: "Decreto 119 de 2019 art 411",
  },

  {
    key: "2",
    identificacion: "BELLO",
    departamento: "ANTIOQUIA",
    regional: "ANTIOQUIA",
    normatividad: "Acuerdo 020 de 2020 art 77",
  },
  {
    key: "3",
    identificacion: "CARTAGENA",
    departamento: "BOLIVAR",
    regional: "CARIBE",
    normatividad: "Decreto 112 de ene 2023 art 8",
  },
  {
    key: "4",
    identificacion: "COPACABANA",
    departamento: "ANTIOQUIA",
    regional: "ANTIOQUIA",
    normatividad:
      "Acuerdo 0182 de 2024 art 77 y Resolución 2024000SHI447 dic 2024",
  },
  {
    key: "5",
    identificacion: "DOSQUEBRADAS",
    departamento: "RISARALDA",
    regional: "ANTIOQUIA",
    normatividad: "Acuerdo 033 del 30 Dic 2020 art 110",
  },

  {
    key: "7",
    identificacion: "MAICAO",
    departamento: "LA_GUAJIRA",
    regional: "CARIBE",
    normatividad: "Acuerdo 04 de 2023 art 128",
  },
  {
    key: "8",
    identificacion: "MEDELLÍN",
    departamento: "ANTIOQUIA",
    regional: "ANTIOQUIA",
    normatividad:
      "Resolución 202250128894 de 2022 y art 77 de Acuerdo 93 de 2023",
  },
  {
    key: "9",
    identificacion: "PEREIRA",
    departamento: "RISARALDA",
    regional: "ANTIOQUIA",
    normatividad: "Resolución 35 de 2021",
  },
  {
    key: "10",
    identificacion: "RIOHACHA",
    departamento: "LA_GUAJIRA",
    regional: "CARIBE",
    normatividad: "Acuerdo 11 de 2020 art 118",
  },

  {
    key: "13",
    identificacion: "SOLEDAD",
    departamento: "ATLANTICO",
    regional: "CARIBE",
    normatividad: "Acuerdo 211 de 2016 art 52",
  },
  {
    key: "14",
    identificacion: "MEDELLÍN",
    departamento: "ANTIOQUIA",
    regional: "ANTIOQUIA",
    normatividad: "Resolución No 202550098566 de 2025",
  },
  {
    key: "15",
    identificacion: "MALAMBO",
    departamento: "ATLANTICO",
    regional: "CARIBE",
    normatividad: "Acuerdo 014 de 2024 art 465",
  },
  {
    key: "16",
    identificacion: "SOACHA",
    departamento: "CUNDINAMARCA",
    regional: "CENTRO",
    normatividad: "Art 380 Acuerdo 30 del 2020",
  },

  {
    key: "18",
    identificacion: "BUCARAMANGA",
    departamento: "SANTANDER",
    regional: "ORIENTE",
    normatividad: "Resolución 2248 del 2025 Art 1",
  },

  {
    key: "19",
    identificacion: "GIRON",
    departamento: "SANTANDER",
    regional: "ORIENTE",
    normatividad: "Art 2 Acuerdo 059 de 2018",
  },
  {
    key: "20",
    identificacion: "PIEDECUESTA",
    departamento: "SANTANDER",
    regional: "ORIENTE",
    normatividad: "Art 107 Acuerdo 019 de 2022",
  },
  {
    key: "21",
    identificacion: "ARMENIA",
    departamento: "QUINDIO",
    regional: "ANTIOQUIA-EJE CAFETERO",
    normatividad: "Art 1. Resolución No. 818 del 10 de diciembre de 2025",
  },
  {
    key: "22",
    identificacion: "MADRID",
    departamento: "CUNDINAMARCA",
    regional: "CENTRO",
    normatividad: "Acuerdo No 004 de 2025",
  },
  {
    key: "23",
    identificacion: "MOSQUERA",
    departamento: "CUNDINAMARCA",
    regional: "CENTRO",
    normatividad: "Art 22. Acuerdo 020 de 2025",
  },
  {
    key: "24",
    identificacion: "LA ESTRELLA",
    departamento: "ANTIOQUIA",
    regional: "ANTIOQUIA",
    normatividad: "Resolución 2026-003787-agosto 18 de 2026",
  },
];

const handleContactClick = () => {
  Swal.fire({
    title: "<strong>Información de Contacto</strong>",
    icon: "info",
    html: `
      <div style="text-align: left; font-size: 1rem; line-height: 1.5;">
        <p style="margin-bottom: 1rem;">Para más información contáctese con:</p>
        <div style="margin-bottom: 1rem;">
          <p><b>Área de Impuestos:</b></p>
          <p>Tel: (601) 5806419 Ext 1629 – 1626</p>
          <p>Email:jcortes@icontec.org</a> – 
          <a >dchaparro@icontec.org</a></p>
        </div>
        <div style="margin-bottom: 1rem;">
          <p><b>Área de Facturación:</b></p>
          <p>Email: amparra@icontec.org</a></p>
        </div>
      </div>
    `,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: true,
    confirmButtonText: "Cerrar",
    confirmButtonAriaLabel: "Cerrar",
    width: "90%", // Hacemos el cuadro de diálogo más ancho para pantallas más pequeñas
    customClass: {
      popup: "responsive-swal-popup",
    },
  });
};
const Row = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props["data-row-key"],
  });
  const style = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging
      ? {
          position: "relative",
          zIndex: 9999,
        }
      : {}),
  };
  const contextValue = useMemo(
    () => ({
      setActivatorNodeRef,
      listeners,
    }),
    [setActivatorNodeRef, listeners],
  );
  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  );
};

const Tabla = () => {
  const [dataSource, setDataSource] = useState(initialData);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDataSource((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id,
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id,
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });
    }
  };
  const handleDownloadComercio = () => {
    const url =
      "https://storagecompartidoicontec.blob.core.windows.net/documentoscompartidos/CAMARA DE COMERCIO JUNIO2025.pdf"; // Reemplaza con la URL del documento
    window.open(url, "_blank");
  };

  const handleDownloadRUT = () => {
    const url =
      "https://storagecompartidoicontec.blob.core.windows.net/documentoscompartidos/20260602 RUT ICONTEC2025.pdf"; // Reemplaza con la URL del documento
    window.open(url, "_blank");
  };

  return (
    <div className="table-container">
      <header>
        <div className="button-group">
          <Button className="custom-button" onClick={handleDownloadComercio}>
            Descargar Camara de Comercio
          </Button>
          <Button className="custom-button" onClick={handleDownloadRUT}>
            Descargar RUT
          </Button>
          <Button className="custom-button" onClick={handleContactClick}>
            Contactenos
          </Button>
        </div>
      </header>
      <a>
        <h5>
          Abstenerse de practicar retención de industria y comercio en las
          siguientes ciudades en las que tenemos calidad de AUTORETENEDORES DE
          ICA
        </h5>
      </a>
      <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
        <SortableContext
          items={dataSource.map((i) => i.key)}
          strategy={verticalListSortingStrategy}
        >
          <Table
            rowKey="key"
            components={{
              body: {
                row: Row,
              },
            }}
            columns={columns(
              searchText,
              setSearchText,
              searchedColumn,
              setSearchedColumn,
              searchInput,
            )}
            dataSource={dataSource}
          />
        </SortableContext>
      </DndContext>
      <Footer />
    </div>
  );
};

export default Tabla;
